import React, { useRef, useState } from "react";
import styled from "styled-components";
import Button from "./Button";
import Flex from "./Flex";
import { uploadErrorMessage, uploadFile } from "../uploads";

const Container = styled.div<any>`
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 6px 12px;
  margin-right: 6px;
`;

type UploaderProps = {
  onChange: any;
  value: string | null;
};

const FileUploader = ({ onChange, value }: UploaderProps) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const [uploadProgress, setUploadProgress] = useState<number | null>(null);

  const uploadImage = async () => {
    const file = (fileRef?.current?.files || [])[0];

    if (file == null) {
      return;
    }

    setUploadProgress(0);

    uploadFile(file, setUploadProgress)
      .then((key) => onChange(key))
      .catch((err) => alert(uploadErrorMessage(err)))
      .finally(() => setUploadProgress(null));
  };

  const startUpload = () => {
    fileRef.current?.click();
  };

  return (
    <Flex>
      <input
        type="file"
        ref={fileRef}
        style={{ display: "none" }}
        onChange={uploadImage}
      />
      <Container>
        {uploadProgress != null
          ? `Uploading ${uploadProgress}%`
          : value || "No File Uploaded"}
      </Container>
      <Button onClick={startUpload} type="button">
        Change
      </Button>
    </Flex>
  );
};

export default FileUploader;
